import { CalendarDaysIcon, ClockIcon, LightBulbIcon, UserGroupIcon } from "@heroicons/react/20/solid";
import { Checklist } from "@/components/getting-started/SetupChecklist";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Actions as COMPANY_ACTIONS } from "@/redux/actions/companyActions";
import { Actions as EMPLOYEE_ACTIONS } from "@/redux/actions/employeeActions";
import { useEffect, useMemo } from "react";
import BuddyLogo from "../../images/buddy-face.png";

const SetUpModeCompany = ({
	settings,
	jurisdiction,
	periods,
	employees,
	cola,
	employeesGetListWithSalary,
	selectedMethod,
	getCola,
	creditBalance,
	updateCompanyDetails,
}) => {
	useEffect(() => {
		switch (jurisdiction) {
			case "MT":
				getCola();
				break;
		}
		employeesGetListWithSalary({
			from: `${new Date().getFullYear()}-01-01`,
			to: `${new Date().getFullYear()}-12-31`,
		});
	}, []);

	const companySetUp = useMemo(() => {
		const checklist = Checklist({
			jurisdiction,
			settings,
			employees,
			periods,
			cola,
			selectedMethod,
			creditBalance,
		});
		let stepsRequired = 0;
		let stepsCompleted = 0;
		let steps = [];
		checklist?.map(({ list }) => {
			list?.map(({ title, progress, target }) => {
				if (target === progress) {
					steps.push(title);
					stepsCompleted++;
				}
				stepsRequired++;
			});
		});
		return stepsRequired === stepsCompleted;
	}, [
		JSON.stringify(settings),
		jurisdiction,
		periods?.length,
		employees?.length,
		cola?.length,
		selectedMethod?.value,
		creditBalance,
	]);
	return (
		<div
			className="block text-center bg-white"
			style={{ paddingTop: 120 }}
		>
			<div id="all-done">
				<div
					className="item item-circle bg-success"
					style={{ position: "relative", height: "8rem", width: "8rem", marginBottom: "2rem" }}
				>
					<ClockIcon
						style={{ position: "absolute", height: "6rem", color: "white", right: "1rem", top: "1rem" }}
					/>
				</div>
				<div
					className="item item-circle bg-primary"
					style={{
						position: "relative",
						height: "12rem",
						width: "12rem",
						marginLeft: "1rem",
						marginRight: "1rem",
					}}
				>
					<UserGroupIcon
						style={{ position: "absolute", height: "10rem", color: "white", right: "1rem", top: "1rem" }}
					/>
				</div>
				<div
					className="item item-circle bg-danger"
					style={{ position: "relative", height: "8rem", width: "8rem", marginBottom: "2rem" }}
				>
					<CalendarDaysIcon
						style={{ position: "absolute", height: "6rem", color: "white", right: "1rem", top: "1rem" }}
					/>
				</div>
				<div className="main">
					<h1 className="font-w700 text-center"></h1>
					<h4 className="text-center">
						{companySetUp
							? "You're all set!"
							: "This page is unaccessible until the company is fully set up."}
					</h4>
					<p className="text-center">
						{companySetUp
							? "You can now run your first payroll."
							: "Please finish setting up this company to access this feature."}
					</p>
					{companySetUp ? (
						<button
							className="btn btn-primary"
							style={{ marginTop: "2rem" }}
							onClick={() => {
								updateCompanyDetails({
									org: settings?.org,
									status: "Active",
								});
							}}
						>
							Go Live
							<img
								src={BuddyLogo}
								style={{ marginLeft: "1rem", height: "2rem" }}
							/>
						</button>
					) : (
						<Link
							to="/organisation/setup"
							className="btn btn-primary"
							style={{ marginTop: "2rem" }}
						>
							<LightBulbIcon style={{ height: "1.5em", float: "left", paddingRight: "5" }} />
							<div style={{ float: "left" }}>Getting Started</div>
						</Link>
					)}
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		cola: state.cola?.sortedEmployees,
		employees: state.employees?.employeeListWithSalary,
		settings: state.company?.settings,
		periods: state.payPeriods?.periods,
		jurisdiction: state.company?.settings?.jurisdiction,
		selectedMethod: state.company?.settings?.defaultCard,
		creditBalance: state.payment?.stats?.creditBalance,
	};
};

const mapDispatchToProps = (dispatch) => ({
	updateCompanyDetails: (body) => dispatch(COMPANY_ACTIONS.updateCompanyDetails(body, true)),
	employeesGetListWithSalary: (body) => dispatch(EMPLOYEE_ACTIONS.employeesGetListWithSalary(body)),
	getCola: () => dispatch(EMPLOYEE_ACTIONS.getCola()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SetUpModeCompany);
